import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  FormControl,
  FormLabel,
  Input,
  Flex,
  SimpleGrid,
  Select,
  useToast,
  Checkbox,
} from '@chakra-ui/react';
import { getData } from '../../utils/httpClient';

export default function CreatetModal({
  isOpen,
  onClose,
  formData,
  setFormData,
  onConfirm,
}) {
  const [studyList, setStudyList] = useState([]);
  const [studyPlans, setStudyPlans] = useState([]);
  const toast = useToast();

  const getStudyList = async () => {
    try {
      const response = await getData('/study');
      setStudyList(response?.payload?.studies || []);
    } catch (error) {
      toast({
        title: 'Error al cargar los estudios.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const getStudyPlans = async (studyId) => {
    try {
      const response = await getData(`/studyPlans/findByStudyId/${studyId}`);
      console.log(response);
      setStudyPlans(response?.payload?.studyPlans || []);
    } catch (error) {
      toast({
        title: 'Error al cargar los planes.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getStudyList();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === 'maxAbsencesPercentage' ||
        name === 'maxAbsencesPercentagePractic' ||
        name === 'cycle' ||
        name === 'studyPlanId' ||
        name === 'studyId'
          ? Number(value)
          : value,
    }));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        maxWidth={{ base: '100%', md: '80%' }}
        minHeight={'85vh'}
        maxHeight={'85vh'}
        overflowY="auto"
      >
        <ModalHeader mb={5}>Agregar materia</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
            align="center"
          >
            <Box flex="1" mb={5}>
              <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={5} mt={4}>
                <FormControl id="studyId" isRequired>
                  <FormLabel>Estudio</FormLabel>
                  <Select
                    name="studyId"
                    value={formData.studyId || ''}
                    onChange={(e) => {
                      const studyId = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        studyId: Number(studyId),
                        studyPlanId: '',
                      }));
                      if (studyId) {
                        getStudyPlans(studyId);
                      } else {
                        setStudyPlans([]);
                      }
                    }}
                  >
                    <option value="">Seleccione</option>
                    {studyList.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.description}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl id="studyPlanId" isRequired>
                  <FormLabel>Plan</FormLabel>
                  <Select
                    name="studyPlanId"
                    value={formData.studyPlanId || ''}
                    onChange={handleInputChange}
                    isDisabled={!studyPlans.length}
                  >
                    <option value="">Seleccione</option>
                    {studyPlans.map((plan) => (
                      <option key={plan.id} value={plan.id}>
                        {plan.description}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl id="description" isRequired>
                  <FormLabel>Nombre</FormLabel>
                  <Input
                    name="description"
                    value={formData.description || ''}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl id="cycle" isRequired>
                  <FormLabel>Ciclo</FormLabel>
                  <Input
                    type="number"
                    name="cycle"
                    value={formData.cycle || ''}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl
                  id="mandatory"
                  display="flex"
                  alignItems="center"
                  gridColumn="span 2"
                >
                  <Checkbox
                    name="mandatory"
                    isChecked={formData.mandatory || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mandatory: e.target.checked,
                      }))
                    }
                  >
                    ¿Es obligatoria?
                  </Checkbox>
                </FormControl>

                <FormControl
                  id="maxAbsencesPercentage"
                  isDisabled={!formData.mandatory}
                >
                  <FormLabel>% Máx. Inasistencias</FormLabel>
                  <Input
                    type="number"
                    name="maxAbsencesPercentage"
                    value={formData.maxAbsencesPercentage || ''}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl
                  id="exam"
                  display="flex"
                  alignItems="center"
                  gridColumn="span 2"
                >
                  <Checkbox
                    name="exam"
                    isChecked={formData.exam || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        exam: e.target.checked,
                      }))
                    }
                  >
                    Tiene examen
                  </Checkbox>
                </FormControl>

                <FormControl
                  id="practic"
                  display="flex"
                  alignItems="center"
                  gridColumn="span 2"
                >
                  <Checkbox
                    name="practic"
                    isChecked={formData.practic || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        practic: e.target.checked,
                      }))
                    }
                  >
                    Tiene práctica
                  </Checkbox>
                </FormControl>

                <FormControl
                  id="isExonerable"
                  display="flex"
                  alignItems="center"
                  gridColumn="span 2"
                >
                  <Checkbox
                    name="isExonerable"
                    isChecked={!!formData.isExonerable}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        isExonerable: e.target.checked,
                      }))
                    }
                  >
                    Exonerable
                  </Checkbox>
                </FormControl>

                <FormControl
                  id="maxAbsencesPercentagePractic"
                  isDisabled={!formData.practic}
                >
                  <FormLabel>% Máx. Inasistencias Práctica</FormLabel>
                  <Input
                    type="number"
                    name="maxAbsencesPercentagePractic"
                    value={formData.maxAbsencesPercentagePractic || ''}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </SimpleGrid>
            </Box>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Box>
            <Button colorScheme="blue" onClick={onConfirm} width="120px">
              Completar
            </Button>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
